// src/components/cart/CartItemRow.tsx
import React from "react";
import { Link } from "react-router-dom";
import { Trash2, MapPin } from "lucide-react";
import { ListingImage } from "../landing/ListingImage";
import { mediaIcon } from "../landing/mediaIcons";
import { formatINR, mediaTypeLabel } from "../../utils/listingFormat";
import { DisplayListing, getListingTotal, getListingPhotos } from "../../utils/cartDisplay";

export function CartItemRow({
  listing,
  onRemove,
}: {
  listing: DisplayListing | undefined | null;
  onRemove: (id: string) => void;
}) {
  if (!listing || !listing.id) {
    return (
      <div className="flex items-center justify-between gap-4 rounded-xl border border-red-200 bg-red-50 p-3">
        <p className="text-sm text-red-600">This cart item is missing data and can&apos;t be displayed.</p>
      </div>
    );
  }

  const Icon = mediaIcon(listing.mediaType ?? "hoarding");
  const total = getListingTotal(listing);
  const photos = getListingPhotos(listing);

  return (
    <div className="flex items-center gap-4 rounded-xl border border-slate-200 bg-white p-3">
      <Link to={`/listings/${listing.id}`} className="h-20 w-24 shrink-0 overflow-hidden rounded-lg bg-slate-100">
        <ListingImage photos={photos} alt={listing.title ?? "Listing"} className="h-full w-full object-cover" />
      </Link>

      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-1.5 text-[11px] font-medium text-slate-500">
          <Icon className="h-3.5 w-3.5" /> {mediaTypeLabel(listing.mediaType ?? "")}
        </div>
        <Link to={`/listings/${listing.id}`}>
          <h3 className="mt-0.5 truncate text-sm font-semibold text-[#0F172A] hover:text-[#1D9BD8]">
            {listing.title ?? "Untitled space"}
          </h3>
        </Link>
        <p className="mt-0.5 flex items-center gap-1 text-xs text-slate-400">
          <MapPin className="h-3 w-3" /> {listing.area ?? "-"}, {listing.city ?? "-"}
        </p>
      </div>

      <div className="shrink-0 text-right">
        <p className="text-sm font-semibold text-[#0F172A]">{formatINR(total)}</p>
        <button
          onClick={() => onRemove(listing.id)}
          className="mt-1.5 inline-flex items-center gap-1 text-xs font-medium text-slate-400 hover:text-red-500"
        >
          <Trash2 className="h-3.5 w-3.5" /> Remove
        </button>
      </div>
    </div>
  );
}